import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'

const PaperlessInfoModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="PaperlessInfoModal">
      <h2> Paperless Document Enrollment</h2>
      <p>
        You’ll receive regulatory documents (such as account statements,
        trade confirmations, and account agreements) through email.
        For certain account statements,
        you’ll receive an email to view them on the Schwab website.
      </p>
      <p>
        You can change this at any time.
      </p>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Got it!
        </button>
      </div>
    </FullscreenModal>
  )
}

PaperlessInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(PaperlessInfoModal, 'paperlessInfoModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/PaperlessInfoModal/PaperlessInfoModal.jsx